/**
 * EmailField - Email input with mail icon
 *
 * Use with React Hook Form:
 * <EmailField label="Email" error={errors.email?.message} {...register('email')} />
 */

import { Mail } from 'lucide-react';
import { forwardRef } from 'react';

import { TextField, type TextFieldProps } from './TextField';

export type EmailFieldProps = Omit<TextFieldProps, 'type' | 'icon'>;

export const EmailField = forwardRef<HTMLInputElement, EmailFieldProps>((props, ref) => (
  <TextField ref={ref} type="email" icon={<Mail className="h-4 w-4" />} {...props} />
));

EmailField.displayName = 'EmailField';
